import React, { useRef, useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

import * as AuthServices from '../services/auth.service';
import { ATLEAST_ONE_CAPITAL_REGEX, ATLEAST_ONE_NUMBER_REGEX, ATLEAST_ONE_SMALL_REGEX, ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, ROLE, SWAL_SETTINGS } from "../../../utils/Constants";
import { PHONE_VALIDATION } from "../../../utils/CommonValidatiobn";
import Swal from "sweetalert2";
import { clearUserSession, handleServerValidations, setLocalKey } from "../../../utils/commonfunction";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addProfileData } from "../../../redux/slices/profileslice";

function OtpAdvertiser() {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const Dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  const [timer, setTimer] = useState(60);
  const inputsRef = useRef([]); // store refs to all 6 input boxes

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);
    
  const formik = useFormik({
      enableReinitialize: true,
      initialValues: {
        otp: "", // single field to hold all 6 digits
      },
      validationSchema: Yup.object({
        otp: Yup.string()
          .length(6, "OTP must be 6 digits")
          .required("OTP is required")
          .matches(/^[0-9]+$/, "Only numbers allowed"),
      }),
      onSubmit: (values, { setSubmitting, resetForm }) => {
        let formData = new FormData();
        
        formData.append("_id", searchParams.get('user_id'));
        formData.append("otp", values.otp);
        formData.append("type", searchParams.get('login_method'));

        setSubmitted(false);
        AuthServices
          .otpVerification(formData)
          .then((response) => {
            setSubmitted(true);

            if (response.success) {
              clearUserSession();
              setLocalKey(ROLE.ADVERTISER, JSON.stringify(response.data));
              setLocalKey(ROLE.USER, JSON.stringify(response.data));
              Dispatch(addProfileData(response.data));
              
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });

              if(!response.data.isBusinessRegistered){
                navigate(`../profile-setup`);
              }else if(!response.data.isKycRegistered){
                navigate(`../kyc-details`);
              }
              navigate('../dashboard');  
              // resetForm({ values: "" });
              // setUpdateData(!updateData);

              
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            setSubmitted(true);
            console.log("error ====> ", error);
          });
      },
    });
  
  // handle typing in each box
  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, ""); // allow only digits
    if (!value) return;

    // build the OTP string
    const otpArray = formik.values.otp.split("");
    otpArray[index] = value;
    const newOtp = otpArray.join("").padEnd(6, ""); // keep consistent length
    formik.setFieldValue("otp", newOtp);

    // move focus to next box
    if (index < inputsRef.current.length - 1) {
      console.log('focus movivng');
      inputsRef.current[index + 1].focus();
    }
  };

  // handle backspace to move to previous input
  const handleKeyDown = (e, index) => {
    console.log('backspace', index, e.target.value);
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      console.log('backspace');
      const otpArray = formik.values.otp.split("");
      otpArray[index - 1] = "";
      formik.setFieldValue("otp", otpArray.join("").padEnd(6, ""));
      inputsRef.current[index - 1].focus();
    }
  };

   // helper: get character at given position
  const getChar = (index) => formik.values.otp[index] || "";

  const resendOTP = ()=>{
    let formData = new FormData();
    formData.append("_id", searchParams.get('user_id'));
    formData.append("type", searchParams.get('login_method'));

    AuthServices
      .resendOTP(formData)
      .then((response) => {
        setSubmitted(true);

        if (response.success) {
          // setLocalKey("super_admin", JSON.stringify(response.data));
          // Dispatch(addProfileData(response.data));
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
          setTimer(60);
          
          // resetForm({ values: "" });
          // setUpdateData(!updateData);

          
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      })
      .catch((error) => {
        setSubmitted(true);
        console.log("error ====> ", error);
      });
  }

  return (
    <section className="py-8 md:py-12 lg:py-16 form-bg">
      <div className="container">
        <div className="mb-8">
          <h1 className="headings-h1 text-center text-zinc-950 mb-2">
            {searchParams.get('login_method')=='phone' ? 'Phone Number' : 'Email'} Verification
          </h1>
          <p className="text-center text-zinc-500 body-lg">
            Enter the OTP sent to your {searchParams.get('login_method')=='phone' ? 'phone' : 'email'}
          </p>
        </div>
        <div className="bg-white p-[15px] md:p-[50px] rounded-[10px] max-w-[475px] shadow-[0px_2px_24px_rgba(0,0,0,0.05)] w-full mx-auto border border-zinc-100 w-full">
          <form onSubmit={formik.handleSubmit}>
            {/* <div className="otp-box flex items-center gap-[10px]">
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
              <input
                type="text"
                className="form-control-custom text-center"
                placeholder="0"
              />
            </div> */}

            <div className="otp-box flex items-center gap-[10px] justify-center">
              {[...Array(6)].map((_, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  ref={(el) => (inputsRef.current[index] = el)}
                  value={getChar(index)}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="form-control-custom text-center w-10 h-10 border border-gray-300 rounded focus:border-blue-500 focus:outline-none"
                />
              ))}

              <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.otp && formik.touched.otp && formik.errors.otp}
              </span>
            </div>

            <button type="submit" className="btn btn-pri w-full mt-4">
              Verify
            </button>
          </form>
        </div>
        <div className="mt-8 text-center body-md text-zinc-700">
          Didn't receive code?
          {timer > 0 ? (
            <span className="headings-h6 bold text-zinc-500 ml-2">
              Resend in {timer}s
            </span>
          ) : (
            <a
              href="#"
              className="headings-h6 bold text-[var(--secondary-400)] ml-2"
              onClick={(e) => {
                e.preventDefault();
                resendOTP();
              }}
            >
              Resend
            </a>
          )}
        </div>
      </div>
    </section>
  );
}

export default OtpAdvertiser;
